"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _propTypes = _interopRequireDefault(require("prop-types"));

var _react = _interopRequireDefault(require("react"));

var _indexModule = _interopRequireDefault(require("./index.module.scss"));

var _classnames = _interopRequireDefault(require("classnames"));

// Paragraph
// =========
var Paragraph = function Paragraph(_ref) {
  var children = _ref.children,
      _ref$type = _ref.type,
      type = _ref$type === void 0 ? 'medium' : _ref$type,
      className = _ref.className,
      inlineStyles = _ref.inlineStyles,
      dataTestId = _ref.dataTestId;
  return /*#__PURE__*/_react.default.createElement("p", {
    className: (0, _classnames.default)(_indexModule.default[type], className),
    style: inlineStyles,
    "data-test-id": dataTestId
  }, children);
};

Paragraph.propTypes = {
  type: _propTypes.default.oneOf(['large', 'medium', 'small']),
  className: _propTypes.default.string,
  dataTestId: _propTypes.default.string
};
var _default = Paragraph;
exports.default = _default;